// Potência (rx/tx) de ONU/CTO no FTTH. Sem leitura chega do backend como NaN
// (0 em dados antigos) — nunca como -40, que é queda.

export const SEM_DADOS = "-";

const leitura = (v) => {
  const n = Number.parseFloat(v);
  return Number.isFinite(n) && n !== 0 ? n : NaN;
};

export const semLeitura = (v) => Number.isNaN(leitura(v));

// Modo de análise do elemento, das Configurações Globais > Análise de potência:
// "rx" | "tx" | "ambos" (padrão), separado para ONU e CTO
export const modoAnalise = (config, elemento) =>
  config?.configuracoes?.ftth?.analisePotencia?.[
    elemento?.tipoElemento === "cto" ? "cto" : "onu"
  ] ?? "ambos";

// Valor usado na análise (cor, faixa, filtro, ordenação). Mesma regra do
// backend (potenciaCor): "rx"/"tx" usam só aquela leitura; "ambos" usa o menor
// entre rx e tx quando há os dois e, com um só, ele. Sem leitura: NaN.
export function potenciaAnalise(potencia, modo = "ambos") {
  const rx = leitura(potencia?.rx);
  const tx = leitura(potencia?.tx);
  if (modo === "rx") return rx;
  if (modo === "tx") return tx;
  if (Number.isNaN(rx)) return tx;
  if (Number.isNaN(tx)) return rx;
  return Math.min(rx, tx);
}

// Atalho: potência de análise de uma ONU/CTO conforme a configuração
export const potenciaElemento = (elemento, config) =>
  potenciaAnalise(elemento?.data?.potencia, modoAnalise(config, elemento));

// Exibição com 2 casas, ou "-" sem leitura
export const formatPotencia = (v) =>
  semLeitura(v) ? SEM_DADOS : leitura(v).toFixed(2);
